import { InertiaApp } from '@inertiajs/inertia-vue'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import VueFormulate from '@braid/vue-formulate'
import VueLuxon from 'vue-luxon'
import { InertiaProgress } from '@inertiajs/progress/src'
import Auth from './Mixins/Auth'

import axios from 'axios'
axios.defaults.withCredentials = true;


/** Vue Formulate Plugins */
import FormulateVueDatetimePlugin from '@cone2875/vue-formulate-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import FormulateVSelectPlugin from '@cone2875/vue-formulate-select'
import 'vue-select/dist/vue-select.css';

/** Json Viewer Plugins */
import JsonViewer from 'vue-json-viewer'

import LogRocket from 'logrocket'

import * as Sentry from "@sentry/vue"
import { ExtraErrorData as ExtraErrorDataIntegration, CaptureConsole as CaptureConsoleIntegration } from "@sentry/integrations"
// import { Integrations } from "@sentry/tracing"

import VueQRCodeComponent from 'vue-qrcode-component'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.config.productionTip = false

Vue.use(JsonViewer)

Vue.use(InertiaApp)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(VueLuxon)
Vue.use(VueFormulate, {
  plugins: [
    /** https://www.npmjs.com/package/vue-datetime#usage */
    FormulateVueDatetimePlugin,
    FormulateVSelectPlugin,
  ]
})
Vue.mixin(Auth)
Vue.mixin({ methods: { route: window.route } })
Vue.use(require('vue-moment'))
Vue.component('qr-code', VueQRCodeComponent)
Vue.use(Toast)

InertiaProgress.init()

// TODO: remove LogRocket if Sentry.Replay works
LogRocket.init(process.env.MIX_LOGROCKET_ID)

Sentry.init({
  Vue,
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
  environment: process.env.MIX_APP_ENV || 'development',
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 1.0,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    new ExtraErrorDataIntegration({
      // limit of how deep the object serializer should go. Anything deeper than limit will
      // be replaced with standard Node.js REPL notation of [Object], [Array], [Function] or
      // a primitive value. Defaults to 3.
      depth: 5
    }),
    new CaptureConsoleIntegration(
      {
        // array of methods that should be captured
        // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
        levels: ['log', 'warn', 'error', 'debug']
      }
    ),
    new Sentry.Replay({
      // Additional SDK configuration goes in here, for example:
      maskAllText: false,
      blockAllMedia: true,
      networkDetailAllowUrls: [window.location.origin],
    }),
    // TODO: disable this, since we dont use Vue Router
    //   new Integrations.BrowserTracing({
    //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //     tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    //   }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const el = document.getElementById('app')

new Vue({
  metaInfo: {
    titleTemplate: (title) => title ? `${title} - Dotify` : 'Dotify'
  },
  render: h => h(InertiaApp, {
    props: {
      initialPage: JSON.parse(el.dataset.page),
      resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
      transformProps: props => {
        if (props.auth && props.auth.user) {
          // TODO: remove this if Sentry.Replay works
          LogRocket.identify(props.auth.user.id + "", {
            name: props.auth.user.name,
            email: props.auth.user.email,
          });

          Sentry.setUser({
            id: props.auth.user.id,
            username: props.auth.user.name,
            email: props.auth.user.email,
          });
        }
        return props
      }
    },
  }),
}).$mount(el)


